import React from 'react'
import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'
import { format } from 'date-fns'
import Badge from '@mui/material/Badge'
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined'
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline'
import AddIcon from '@mui/icons-material/Add'
import SearchIcon from '@mui/icons-material/Search'
import { BOTTOM_BAR_HEIGHT } from '@/v2/constants'
import { nowOnClinicTimezone } from '@/v2/utils/convert'
import useModals from '@/v2/hooks/useModals'
import { useNotification } from '@/v2/hooks/messages/useNotification'
import RTNotifications from '@/v2/hooks/subscriptions/messages/RTNotifications'

const Wrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: ${BOTTOM_BAR_HEIGHT};
  background: #1a1a1a;
  display: flex;
  justify-content: space-around;
  align-items: center;
  z-index: 100;
  padding-bottom: env(safe-area-inset-bottom);
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);
`

const NavItem = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding: 12px 16px;
  cursor: pointer;
  color: #fff;

  svg {
    font-size: 26px;
  }

  &:hover {
    opacity: 0.8;
  }
`

const BottomBar = () => {
  const navigate = useNavigate()
  const { goTo } = useModals()
  const today = format(nowOnClinicTimezone(), 'yyyy-MM-dd')
  const { notification = {} } = useNotification()
  const { chat } = notification
  const { messagesUnreadCount = 0, conversationsUnreadCount = 0 } = chat || {}

  const handleCalendar = () => {
    navigate(`/v2/calendar/day/${today}`)
  }

  const handleAdd = () => {
    goTo('/v2/event/new')
  }

  const handleSearch = () => {
    navigate('/v2/search')
  }

  const handleMessages = () => {
    navigate('/v2/messages')
  }

  const hasUnreadMessages =
    messagesUnreadCount > 0 || conversationsUnreadCount > 0

  return (
    <>
      <RTNotifications />
      <Wrapper>
        <NavItem onClick={handleCalendar} aria-label="Calendar">
          <CalendarTodayOutlinedIcon />
        </NavItem>
        <NavItem onClick={handleMessages} aria-label="Messages">
          {hasUnreadMessages ? (
            <Badge
              badgeContent={messagesUnreadCount || ''}
              color="error"
              variant={messagesUnreadCount === 0 ? 'dot' : 'standard'}
            >
              <ChatBubbleOutlineIcon />
            </Badge>
          ) : (
            <ChatBubbleOutlineIcon />
          )}
        </NavItem>
        <NavItem onClick={handleAdd} aria-label="Add">
          <AddIcon />
        </NavItem>
        <NavItem onClick={handleSearch} aria-label="Search">
          <SearchIcon />
        </NavItem>
      </Wrapper>
    </>
  )
}

export default BottomBar
